'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { WikiTableOfContents } from '@/components/wiki/wiki-table-of-contents';
import { WikiTreeSidebar } from '@/components/wiki/wiki-tree-sidebar';
type WikiLayoutProps = {
  // Left sidebar props
  pages: Array<any>;
  selectedPageRef: string | null;
  onPageSelect?: (pageRef: string) => void;
  wikiStructure?: any;

  /**
   * Wiki-level identity, status and actions, rendered under the back link and
   * above the page tree. The layout only places it; the caller decides what
   * the wiki header is.
   */
  sidebarHeader?: ReactNode;

  // Right sidebar props
  content?: string;

  // Main content
  children: ReactNode;

  // View configuration
  isPublicView?: boolean;
  owner?: string;
  repo?: string;
};
export function WikiLayout(t0) {
  const $ = _c(20);
  const {
    pages,
    selectedPageRef,
    onPageSelect,
    wikiStructure,
    sidebarHeader,
    content: t1,
    children,
    isPublicView: t2,
    owner,
    repo
  } = t0;
  const content = t1 === undefined ? "" : t1;
  const isPublicView = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isPublicView || $[1] !== onPageSelect || $[2] !== owner || $[3] !== pages || $[4] !== repo || $[5] !== selectedPageRef || $[6] !== sidebarHeader || $[7] !== wikiStructure) {
    t3 = <aside className="w-64 flex-shrink-0 h-full overflow-y-auto pl-4 pr-4 custom-scrollbar"><WikiTreeSidebar header={sidebarHeader} pages={pages} selectedPageRef={selectedPageRef} onPageSelect={onPageSelect} wikiStructure={wikiStructure} isPublicView={isPublicView} owner={owner} repo={repo} /></aside>;
    $[0] = isPublicView;
    $[1] = onPageSelect;
    $[2] = owner;
    $[3] = pages;
    $[4] = repo;
    $[5] = selectedPageRef;
    $[6] = sidebarHeader;
    $[7] = wikiStructure;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children) {
    t4 = <main id="wiki-main-content" className="flex-1 min-w-0 overflow-y-auto h-full pb-32 pt-12 custom-scrollbar"><div className="w-full px-8">{children}</div></main>;
    $[9] = children;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== content || $[12] !== isPublicView || $[13] !== owner || $[14] !== repo) {
    t5 = <aside className="w-64 flex-shrink-0 h-full overflow-y-auto pl-4 pr-4 custom-scrollbar"><WikiTableOfContents content={content} isPublicView={isPublicView} owner={owner} repo={repo} /></aside>;
    $[11] = content;
    $[12] = isPublicView;
    $[13] = owner;
    $[14] = repo;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = <div className="container mx-auto flex max-w-7xl justify-center h-full">{t3}{t4}{t5}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}